<template>
	<div>
		<div style="text-align: right; padding-bottom: 20px;">
			<el-link type="primary" @click="exportXls">导出XLS</el-link>
		</div>
		<table id="table" class="dtable">
			<tr>
				<td>
					责任部门

				</td>
				<td>
					地区

				</td>
				<td>
					五年高职计划数

				</td>
				<td>
					五年高职完成数
				</td>
				<td>
					五年高职完成率

				</td>
				<td>
					3+3计划数

				</td>

				<td>
					3+3完成数

				</td>
				<td>
					3+3完成率

				</td>
				<td>
					合计计划数

				</td>
				<td>
					合计完成数

				</td>
				<td>
					总完成率

				</td>


			</tr>
			<tr v-for="(item,k,idx) in ShowDataList1" :key="'1a'+k">
				<td>{{item.fzr}}</td>
				<td>{{item.area}}</td>
				<td>{{item.plan}}</td>
				<td>{{item.fiveyear}}</td>
				<td>{{getLv(item.plan/item.fiveyear)}}</td>
				<td>{{item.plan3}}</td>
				<td>{{item.threeyear}}</td>
				<td>{{getLv(item.plan3/item.threeyear)}}</td>
				
				<td>{{item.plan}}</td>
				<td>{{item.fiveyear+item.threeyear}}</td>
				<td>{{item.plan3}}%</td>
				
			</tr>
			<tr v-for="(item,k,idx) in heji_1" :key="'1x'+k">
				<td colspan="2">小计</td>

				<td>{{item.plan}}</td>
				<td>{{item.fiveyear}}</td>
				<td>{{getLv(item.fiveyear/item.plan)}}</td>
				<td>{{item.plan3}}</td>
				<td>{{item.threeyear}}</td>
				<td>{{getLv(item.threeyear/item.plan3)}}</td>
				<td>{{item.plan+item.plan3}}</td>
				<td>{{item.fiveyear+item.threeyear}}</td>
				<td>{{getLv((item.fiveyear+item.threeyear)/(item.plan+item.plan3))}}</td>
			</tr>

			<tr v-for="(item,k,idx) in ShowDataList2" :key="'2'+k">
				<td>{{item.fzr}}</td>
				<td>{{item.area}}</td>
				<td>{{item.plan}}</td>
				<td>{{item.fiveyear}}</td>
				<td>{{getLv(item.fiveyear/item.plan)}}</td>
				<td>{{item.plan3}}</td>
				<td>{{item.threeyear}}</td>
				<td>{{getLv(item.threeyear/item.plan3)}}</td>
				
				<td>{{item.plan+item.plan3}}</td>
				<td>{{item.fiveyear+item.threeyear}}</td>
				<td>{{getLv((item.fiveyear+item.threeyear)/(item.plan+item.plan3))}}</td>
			</tr>

			<tr v-for="(item,k,idx) in heji_2" :key="'1'+k">
				<td colspan="2">小计</td>

				<td>{{item.plan}}</td>
				<td>{{item.fiveyear}}</td>
				<td>{{getLv(item.fiveyear/item.plan)}}</td>
				<td>{{item.plan3}}</td>
				<td>{{item.threeyear}}</td>
				<td>{{getLv(item.threeyear/item.plan3)}}</td>
				<td>{{item.plan+item.plan3}}</td>
				<td>{{item.fiveyear+item.threeyear}}</td>
				<td>{{getLv((item.fiveyear+item.threeyear)/(item.plan+item.plan3))}}</td>
			</tr>

		</table>

	</div>
</template>

<script>
	import XLSX from 'xlsx'
	export default {

		data() {
			return {
				year: localStorage.getItem("year"),
				students: [],
				ShowDataList1: [],
				ShowDataList2: [],

				heji_1: [],
				heji_2: [],
				zongji: [],
				luquStu: []
			}
		},
		mounted() {
			this.getLuqu();

		},
		methods: {
			getLv(p){
				let r = parseInt(p*10000)/100
				if(isNaN(r)){
					return "0%"
				}else{
					return r+"%"
				}
			},
			getLuqu() {



				this.$http.post('/api/sch_area_teacher', {}).then(res2 => {
					let teacherArea = res2.data;
					let getFzr = (areaname) => {
						let fzr = []
						for (let item of teacherArea) {
							if (item.area.indexOf(areaname) >= 0 || areaname.indexOf(item.area) >=
								0) {
								fzr.push(item.username)
							}
						}

						return fzr.join(",")
					}
					this.$http.post('/api/sch_jiaofei_area_stu', {}).then(res => {
						let nanjing = [],
							citys = [];
						let nj_dist = {},
							city_dist = {};
						for (let item of res.data) {
							if (item.graduate_sch_city.indexOf("南京") >= 0) {
								let dist = item.graduate_sch_city.split(",")
								if (dist.length == 3) {
									if (!nj_dist[dist[2]]) {
										nj_dist[dist[2]] = item
									} else {
										nj_dist[dist[2]].num += item.num
									}
								} else {
									if (!nj_dist[item.graduate_sch_city]) {
										nj_dist[item.graduate_sch_city] = item
									} else {
										nj_dist[item.graduate_sch_city].num += item.num
									}
								}

							} else {

								let dist = item.graduate_sch_city.split(",")
								if (dist.length >= 2) {
									if (!city_dist[dist[1]]) {
										city_dist[dist[1]] = item
									} else {
										city_dist[dist[1]].num += item.num
									}

								} else {
									if (!city_dist[item.graduate_sch_city]) {
										city_dist[item.graduate_sch_city] = item
									} else {
										city_dist[item.graduate_sch_city].num += item.num
									}
								}

							}
						}
						for (let k in nj_dist) {
							nanjing.push({
								area: k,
								fzr: "",
								area_code: nj_dist[k].graduate_dist_code,
								num: nj_dist[k].num,
								plan: 0,
								plan3: 0,
								target: 0,
								fiveyear: 0,
								threeyear: 0,
								baodao: 0,
								total: 0
							})
						}
						for (let k in city_dist) {
							citys.push({
								area: k,
								fzr: getFzr(k),
								area_code: city_dist[k].graduate_dist_code.substr(0,4) + "00",
								num: city_dist[k].num,
								plan: 0,
								plan3: 0,
								target: 0,
								fiveyear: 0,
								threeyear: 0,
								baodao: 0,
								total: 0

							})
						}

						this.getData(nanjing, citys);
						// this.ShowDataList1 = nj_dist
						// this.ShowDataList2 = city_dist
						// console.log(this.ShowDataList1)


					})

				})
			},
			getData(nanjing, citys) {
				this.$http.post('/api/sch_area_major_data_dj', {
					status: 2//录取缴费的改成2
				}).then(res => {
					//this.students = res.data
					//先区分下五年高职和3+3的
					$("#loading").show();
					let majors = {};
					for (let item of res.data.majors) {
						majors[item.id] = item.item_desc
					}

					let heji_1 = {
						fzr: '',
						num: 0,
						plan: 0,
						plan3: 0,
						target: 0,
						fiveyear: 0,
						threeyear: 0,
						baodao: 0,
						total: 0
					};
					let heji_2 = {
						fzr: '',
						num: 0,
						plan: 0,
						plan3: 0,
						target: 0,
						fiveyear: 0,
						threeyear: 0,
						baodao: 0,
						total: 0
					}



					for (let city of citys) {
						for (let item of res.data.areaplan) {
							if (item.area_name.indexOf(city.area) >= 0) {
								
								if (item.item_desc.indexOf("五年") >= 0) {
									city.plan += item.num
								}else{
									city.plan3 += item.num
								}
							}
							
							
						}
						for (let item of res.data.students) {
							if (item.graduate_dist_code == city.area_code) {
								//判断专业类型

								if (majors[item.major_id] == "五年制高职") {
									city.fiveyear += item.num
								} else if (majors[item.major_id] == "3+3专科") {
									city.threeyear += item.num
								}


							}
						}
						for (let item of res.data.tongzhishu) { //实际报道人数，发通知书人数
							if (item.graduate_dist_code == city.area_code) {


								city.baodao += item.num


							}
						}
						heji_2.plan += city.plan
						heji_2.plan3 += city.plan3
						heji_2.fiveyear += city.fiveyear
						heji_2.threeyear += city.threeyear
						heji_2.baodao += city.baodao

					}

					for (let item of res.data.areaplan) {
						if (item.area_name.indexOf("南京") >= 0) {
							if (item.item_desc.indexOf("五年") >= 0) {
								heji_1.plan += item.num
							}else{
								heji_1.plan3 += item.num
							}
							
						}
					}
					for (let city of nanjing) {


						for (let item of res.data.students) {
							if (item.dist_code == city.area_code) {
								//判断专业类型

								if (majors[item.major_id] == "五年制高职") {
									city.fiveyear += item.num
								} else if (majors[item.major_id] == "3+3专科") {
									city.threeyear += item.num
								}


							}
						}
						for (let item of res.data.tongzhishu) { //实际报道人数，发通知书人数
							if (item.dist_code == city.area_code) {


								city.baodao += item.num


							}
						}
						heji_1.plan += city.plan
						heji_1.fiveyear += city.fiveyear
						heji_1.threeyear += city.threeyear
						heji_1.baodao += city.baodao

					}

					this.ShowDataList1 = nanjing
					this.ShowDataList2 = citys
					this.heji_2 = [heji_2]
					this.heji_1 = [heji_1]
					console.log(heji_1)


					this.$nextTick(function() {
						$("#loading").hide();
					})



				})
			},
			getMajorPlan(major_id, data) {
				let total = 0;
				for (let item of data) {
					if (major_id == item.major_id && item.num) {
						total += item.num
					}
				}
				return total
			},
			getFee(major_id, data) {
				let total = 0;
				for (let item of data) {
					if (major_id == item.major_id && item.num) {
						total += item.num
					}
				}
				return total
			},
			getToudang(major_id, data) {
				let total = 0;
				for (let item of data) {
					if (major_id == item.major_id && item.stu_num) {
						total += item.stu_num
					}
				}
				return total
			},


			exportXls() {
				let workbook = XLSX.utils.table_to_book(document.getElementById('table'))
				try {
					XLSX.writeFile(workbook, '已缴费人数统计表' + parseInt(Math.random() * 10000) + '.xlsx');
				} catch (e) {
					console.log(e, workbook);
				}
			}
		},
	}
</script>

<style scoped="scoped">
	.datatable {
		background-color: #E4E7ED;
		width: 100%;
	}

	.datatable td {
		background-color: #fff;
		text-align: center;
		padding: 10px 0;
	}
</style>
